import React from "react";
import {Pagination} from 'react-bootstrap';
import STCPaginationItem from "./STCPagination.Item/STCPagination.Item";
import STCPaginationEllipsis from "./STCPagination.Ellipsis/STCPagination.Ellipsis";
import STCPaginationNext from "./STCPagination.Next/STCPagination.Next";
import STCPaginationPrev from "./STCPagination.Prev/STCPagination.Prev";
import STCPaginationLast from "./STCPagination.Last/STCPagination.Last";
import STCPaginationFirst from "./STCPagination.First/STCPagination.First";

function STCPagination(props){

    return(
        <Pagination
            style={props.style}
            className={props.className}

            size={props.size}
            bsPrefix={props.bsPrefix}
        >
            {props.children}
        </Pagination>
    )
}

STCPagination.Ellipsis = STCPaginationEllipsis;
STCPagination.Item = STCPaginationItem;
STCPagination.Next = STCPaginationNext;
STCPagination.Prev = STCPaginationPrev;
STCPagination.First = STCPaginationFirst;
STCPagination.Last = STCPaginationLast;

export default STCPagination;